import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { Box, GlobalStyles } from '@mui/material';
import { useTheme } from '../themeContext';

// -- Components
import Container from '../components/login/Container';
import DeletedAccount from '../components/login/popups/DeletedAccount';
import BlockedAccountPopup from '../components/login/popups/BlockedAccountPopup';
import LoginAttemptsWarningPopup from '../components/login/popups/LoginAttemptsWarningPopup';

// Utils
import clearLocalStorage from '../util/storage/clearLocalStorage';
import clearCookies from '../util/storage/clearCookies';

const Login: React.FC = () => {
  const { isLightMode, toggleTheme } = useTheme();
  const colors = useAppSelector(state => state.theme.colors);
  const isDeletedAccountPopupOpened = useAppSelector(state => state.navigation.isDeletedAccountPopupOpened);
  const isBlockedAccountPopupOpened = useAppSelector(state => state.navigation.isBlockedAccountPopupOpened);
  const isLoginAttemptsWarningPopupOpened = useAppSelector(state => state.navigation.isLoginAttemptsWarningPopupOpened);

  const bg = colors?.background || '#f4f5f7';

  useEffect(() => {
    if (isLightMode) {
      toggleTheme();
    }
  }, [isLightMode, toggleTheme]);

  useEffect(() => {
    clearLocalStorage();
    clearCookies();
  }, []);

  return (
    <>
      <GlobalStyles styles={{ body: { backgroundColor: bg } }} />
      <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2 }}>

        <Container />

        {isDeletedAccountPopupOpened && <DeletedAccount />}
        {isBlockedAccountPopupOpened && <BlockedAccountPopup />}
        {isLoginAttemptsWarningPopupOpened && <LoginAttemptsWarningPopup />}
        
      </Box>
    </>
  );
};

export default Login;